import { render, staticRenderFns } from "./SGoods.vue?vue&type=template&id=282d715c&scoped=true"
import script from "./SGoods.vue?vue&type=script&lang=js"
export * from "./SGoods.vue?vue&type=script&lang=js"
import style0 from "./SGoods.vue?vue&type=style&index=0&id=282d715c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d715c",
  null
  
)

export default component.exports